const routes = {
  TENANT_CONFIGURATION: '/tenants/<tenant_id>/configuration',
  CREATE_DROPOFF: '/store',
  GET_QR_CODE: '/store/<store_id>/qrcode?contributorEmail=<email>',
  SEND_CODE_BY_EMAIL: '/store/<store_id>/qrcode/sendbymail',
  UPLOAD_DROPOFF_PICTURE: '/store/<dropoff_id>/picture'
}

export default routes
